import React, { useState } from "react";
import { postEmpleado as addEmpleado } from "../helpers/rutaEmpleados";
import "../css/addclienteform.css";
import { Modal } from "react-bootstrap";
import "animate.css";

const AddEmpleadoForm = ({ setShow }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const [formValues, setFormValues] = useState({
    nombre: "",
    apellido: "",
    dni: "",
    domicilio: "",
    telefono: "",
    cargo: "",
    sueldoActual: "",
    observaciones: "",
  });

  const resetForm = () => {
    setFormValues({
      nombre: "",
      apellido: "",
      dni: "",
      domicilio: "",
      telefono: "",
      cargo: "",
      sueldoActual: "",
      observaciones: "",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues({
      ...formValues,
      [name]: name === "sueldoActual" ? value.replace(/[^\d.]/g, "") : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        ...formValues,
        sueldoActual: Number(formValues.sueldoActual || 0),
      };

      const resp = await addEmpleado(payload);
      console.log("✅ Empleado creado:", resp);

      if (!resp?.ok) {
        console.error("❌ Error al crear empleado:", resp?.error || resp);
        return;
      }

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        resetForm();

        // Si querés cerrar el modal al guardar, descomentá:
        // setShow(false);
      }, 2000);
    } catch (error) {
      console.error("❌ Error al crear empleado:", error);
    }
  };

  return (
    <>
      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group mt-3 col-sm-3">
              <label>Apellido</label>
              <input
                type="text"
                className="form-control"
                name="apellido"
                maxLength="50"
                required
                value={formValues.apellido}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-3 col-sm-3">
              <label>Nombre</label>
              <input
                type="text"
                className="form-control"
                name="nombre"
                maxLength="50"
                required
                value={formValues.nombre}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-3 col-sm-2">
              <label>DNI</label>
              <input
                type="text"
                className="form-control"
                name="dni"
                maxLength="20"
                required
                value={formValues.dni}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-3 col-sm-2">
              <label>Teléfono</label>
              <input
                type="text"
                className="form-control"
                name="telefono"
                maxLength="20"
                value={formValues.telefono}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-3 col-sm-2">
              <label>Cargo</label>
              <input
                type="text"
                className="form-control"
                name="cargo"
                maxLength="50"
                value={formValues.cargo}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group mt-3 col-sm-6">
              <label>Domicilio</label>
              <input
                type="text"
                className="form-control"
                name="domicilio"
                maxLength="100"
                value={formValues.domicilio}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-3 col-sm-3">
              <label>Sueldo Actual</label>
              <input
                type="number"
                className="form-control"
                name="sueldoActual"
                min="0"
                step="0.01"
                required
                value={formValues.sueldoActual}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-3 col-sm-3">
              <label>Observaciones</label>
              <input
                type="text"
                className="form-control"
                name="observaciones"
                maxLength="150"
                value={formValues.observaciones}
                onChange={handleChange}
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="btn btn-dark mt-5 mb-3"
              id="button"
            >
              Guardar
            </button>
          </div>
        </form>
      </div>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Empleado generado correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddEmpleadoForm;